module.exports = __webpack_public_path__ + "static/media/solution-top.e5cd35e2.svg";